// Mobile category picker: the header bar toggles a smoothly expanding dropdown of categories.
// - data-open on the host drives all CSS transitions (panel height via grid rows, fade, item stagger, chevron).
// - Closes on Escape, outside tap/backdrop, choosing a link, or growing to desktop width.
class SCategoryMenu extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('[data-cm-toggle]');
    this.panel = this.querySelector('[data-cm-panel]');
    this.backdrop = this.querySelector('[data-cm-backdrop]');
    if (!this.toggleButton || !this.panel) return;

    this.onToggle = () => this.setOpen(!this.hasAttribute('data-open'));
    this.onKey = (event) => {
      if (event.key === 'Escape' && this.hasAttribute('data-open')) {
        this.setOpen(false);
        this.toggleButton.focus();
      }
    };
    this.onOutside = (event) => {
      if (this.hasAttribute('data-open') && !this.contains(event.target)) this.setOpen(false);
    };
    this.desktop = window.matchMedia('(min-width: 1024px)');
    this.onDesktop = () => { if (this.desktop.matches) this.setOpen(false); };

    this.toggleButton.addEventListener('click', this.onToggle);
    this.backdrop?.addEventListener('click', () => this.setOpen(false));
    this.panel.addEventListener('click', (event) => {
      if (event.target.closest('a')) this.setOpen(false);
    });
    document.addEventListener('keydown', this.onKey);
    document.addEventListener('pointerdown', this.onOutside);
    this.desktop.addEventListener('change', this.onDesktop);
    window.addEventListener('pageshow', () => this.setOpen(false));
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('pointerdown', this.onOutside);
    this.desktop?.removeEventListener('change', this.onDesktop);
  }

  setOpen(open) {
    this.toggleAttribute('data-open', open);
    this.toggleButton.setAttribute('aria-expanded', String(open));
    this.panel.inert = !open;
  }
}

if (!customElements.get('s-category-menu')) customElements.define('s-category-menu', SCategoryMenu);
